;(function () {

"use strict";

var listInputTemplate = require('./templates/list-input.html');

var ListInputView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.$anchor = opts.$anchor;
    this.delimeter = this.$anchor.data('delimeter') || ',';

    $('<div class="add-row"><button class="add btn btn-primary">Add Item</button></div>').prependTo(this.$el);

    this.$el.insertAfter(this.$anchor);

    this.$anchor.hide();

    if (this.$anchor.val()) {
      this.render();
    }
  },
  render: function () {
    var handles = this.$anchor.val().split(this.delimeter);
    console.log(this.delimeter);
    var $add = this.$el.find('.add-row');

    _.each(handles, function (handle) { 
      var html = _.template(listInputTemplate)({handle: handle});
      $(html).insertBefore($add);
    });
  },
  add: function (e) {
    console.log('adding a meta field input row');

    var html = _.template(listInputTemplate)({handle: undefined});
    $(html).insertBefore(this.$el.find('.add-row'));

    return false;
  },
  remove: function (e) {
    var $this = $(e.currentTarget);
    $this.closest('.row').remove();
  },
  val: function () {
    var val = [];
    this.$el.find('.form-group input').each(function () {
      if ($(this).val()) {
        val.push($(this).val());
      }
    });
    return val.join(this.delimeter);
  },
  events: {
    'click .add': 'add',
    'click .remove': 'remove',
  }
});

module.exports = ListInputView;

}());